(ns ballot-scout-v2-frontend.import-manager.common)

(def default-search-state
  {:page 1})
